export class AgendaPost{
   // agendaDetail : AgendaList
    companies_allowed: any[];
    week_slots:  any[];
    exception_slots:any[];
}